import { Grid, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat } from '../../../../helpers';

const TextFiltrosAsistenciasComponent = () => {
  const asistenciasStore = Redux.useSelector((state) => state.asistencias);

  const docentesStore = Redux.useSelector((state) => state.docentes);
  const materiasStore = Redux.useSelector((state) => state.materias);
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const [materia, setMateria] = React.useState(null);
  const [seccion, setSeccion] = React.useState(null);

  const docente = docentesStore.activo;
  const planeva = asistenciasStore.planEvaluacion;

  React.useEffect(() => {
    if (docente && asistenciasStore.params.idMateria) {
      const materiaFind = docente.materias.find(
        (el) => el.id === asistenciasStore.params.idMateria,
      );
      setMateria(materiaFind);
    } else {
      const materiaFind = materiasStore.all.find(
        (el) => el.id === asistenciasStore.params.idMateria,
      );
      setMateria(materiaFind);
    }

    if (docente && asistenciasStore.params.idSeccion) {
      const seccionFind = docente.secciones.find(
        (el) => el.id === asistenciasStore.params.idSeccion,
      );
      setSeccion(seccionFind);
    } else {
      const seccionFind = seccionesStore.all.find(
        (el) => el.id === asistenciasStore.params.idSeccion,
      );
      setSeccion(seccionFind);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asistenciasStore.params]);

  const fechaIgual =
    asistenciasStore.params.desde === asistenciasStore.params.hasta;

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <Stack direction="row" sx={{}}>
          <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
            <strong>Fecha{fechaIgual ? ':' : ' desde:'}</strong>{' '}
            {dateformat(asistenciasStore.params.desde, {
              standard: true,
            })}
            {!fechaIgual && (
              <Typography variant="caption" color="initial">
                <strong> hasta </strong>{' '}
                {dateformat(asistenciasStore.params.hasta, {
                  standard: true,
                })}
              </Typography>
            )}
          </Typography>

          <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
            <strong>Docente:</strong>{' '}
            {asistenciasStore.params.idDocente ? (
              <label>
                {docente.usuario.perfil.pnombre}{' '}
                {docente.usuario.perfil.papellido}
              </label>
            ) : (
              'Todos'
            )}
          </Typography>

          <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
            <strong>Materia:</strong>{' '}
            {asistenciasStore.params.idMateria && materia
              ? materia.nombre ?? '--'
              : 'Todos'}
          </Typography>

          {asistenciasStore.params.idSeccion && seccion ? (
            <Stack direction="row" sx={{}}>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Nivel:</strong>{' '}
                {seccion.nivelAcademico.nivelAcademico.nombre ?? '--'}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Sección:</strong> {seccion.nombre ?? '--'}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Turno:</strong> {seccion.turno ?? '--'}
              </Typography>
            </Stack>
          ) : (
            <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
              <strong>Sección:</strong> Todos
            </Typography>
          )}
          {planeva && (
            <>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Bloque:</strong>{' '}
                {planeva.fechaBloque.bloquePedagogico.nombre}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Fecha de inicio: </strong>
                {planeva.fechaBloque.desde}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Fecha final: </strong>
                {planeva.fechaBloque.hasta}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Período: </strong>
                {planeva.fechaBloque.periodoAcademico.nombre} (
                {planeva.fechaBloque.periodoAcademico.desde}-
                {planeva.fechaBloque.periodoAcademico.hasta})
              </Typography>
            </>
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default TextFiltrosAsistenciasComponent;
